<template>
  <a-card :bordered="false">

    <div>
      <a-tabs defaultActiveKey="1" @change="callback">
        <a-tab-pane tab="机构分库" key="1">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" v-on:keyup.enter="$refs.table.refresh(true)">
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item label="机构名称" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 12px">
                    <a-input v-model="queryParam.storeName" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="企业名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam.enterpriseId" showSearch optionFilterProp="children"
                      @change="handleChange" :filterOption="filterOption">
                      <a-select-option v-for="i in data2" :title="i.enterpriseName" :key="i.enterpriseId">
                        {{ i.enterpriseName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col :span="6">
                  <a-form-item label="服务类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam.serviceType" allowClear="true">
                      <a-select-option v-for="type in restaurantTypes2" :title="type.label" v-bind:value="type.code">
                        {{ type.label }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>


                <a-col :span="6">
                  <a-form-item label="结算方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam.payment" allowClear="true">
                      <a-select-option value="0">先付款</a-select-option>
                      <a-select-option value="1">后付款</a-select-option>
                      <a-select-option value="2">配发</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item label="机构负责人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam.personChargeId" allowClear="true">
                      <tag-select-option v-for="item in boxLis3" :title="item.userName" :value="item.userId">
                        {{ item.userName }}</tag-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col :span="6">
                  <a-row>
                    <a-form-item label="所在省" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 15px">
                      <a-col :span="12">
                        <a-select v-model="queryParam.currentProvince" @change="onchange3" allowClear="true">
                          <a-select-option v-for="type in selectAllProvince" :title="type.provinceName"
                            :key="type.provinceCode">{{ type.provinceName }}</a-select-option>
                        </a-select>
                      </a-col>
                      <a-col :span="12">
                        <a-select v-model="queryParam.currentCity" allowClear="true">
                          <a-select-option v-for="type in selectCityName2" :title="type.cityName" :key="type.cityCode">
                            {{ type.cityName }}</a-select-option>
                        </a-select>
                      </a-col>
                    </a-form-item>
                  </a-row>

                </a-col>

                <span class="table-page-search-submitButtons">
                  <a-row type="flex" justify="space-between">
                    <a-col :span="15"></a-col>
                    <a-col :span="6">
                      <a-button type="primary" style="margin-right: 8px" @click="$refs.table.refresh(true)">查询
                      </a-button>
                      <a-button style="margin-left: 8px" @click="() => queryParam = {}">清空</a-button>
                    </a-col>
                  </a-row>
                </span>

              </a-row>




            </a-form>
          </div>
          <a-divider />
          <div class="table-operator">
            <a-row type="flex" justify="space-between">
              <a-col :span="15"></a-col>
              <a-col :span="4" style="text-align: right">
                <a-button type="primary" v-if="addEnable" icon="plus" @click="$refs.modal.add()">新增</a-button>
              </a-col>
            </a-row>
          </div>
          <s-table size="default" ref="table" rowKey="purchaseOrderId" :columns="columns" :data="loadData"
            :scroll="{ x: '200px' }" bordered>

            <!-- 服务类别-->
            <span slot="serviceTypes" slot-scope="text, record">
              <a-popover>
                <template slot="content">
                  <p v-for="item in record.serviceTypes">{{ item }}</p>
                </template>
                <span class="hover">{{ text }} </span>
              </a-popover>
            </span>

            <!-- 可使用企业 -->
            <span slot="organStoreEnterprises" slot-scope="text, record">
              <a-popover>
                <template slot="content">
                  <p v-for="item in record.organStoreEnterprises">{{ item }}</p>
                </template>
                <span class="hover">{{ text }} </span>
              </a-popover>
            </span>


            <!-- 机构负责人 -->
            <span slot="storePersions" slot-scope="text, record">
              <a-popover>
                <template slot="content">
                  <p v-for="item in record.storePersions">{{ item }}</p>
                </template>
                <span class="hover">{{ text }} </span>
              </a-popover>
            </span>


            <span slot="action" slot-scope="text, record">
              <a v-if="detailsEnabel" @click="detailBtn2(record)">详情</a>
              <a-divider type="vertical" />
              <a v-if="editEnabel" @click="handleEdit(record)">编辑</a>
              <a-divider type="vertical" />
              <a @click="delById(record)" v-if="record.forbiddenStatus == 0 && editEnabel">禁用</a>
              <a @click="delById(record)" v-if="record.forbiddenStatus == 1 && editEnabel">启用</a>
              <a-divider type="vertical" v-if="removeEnable" />
              <a v-if="removeEnable" @click="detailBtn(record)">服务区域</a>
              <a-divider type="vertical" v-if="removeEnable" />
              <a v-if="removeEnable" @click="accessories(record)">查看配件</a>
            </span>

            <span slot="forbiddenStatus" slot-scope="text, record">
              <a-text v-if="record.forbiddenStatus == 0">启用 </a-text>
              <a-text v-else="record.forbiddenStatus ==1">禁用</a-text>
            </span>

            <span slot="payment" slot-scope="text, record">
              <a-text v-if="record.payment == 0">先付款 </a-text>
              <a-text v-else-if="record.payment == 1">后付款</a-text>
              <a-text v-else-if="record.payment == 2">配发</a-text>
            </span>

            <span slot="storeType" slot-scope="text, record">
              <a-text v-if="record.storeType == 0">主库 </a-text>
              <a-text v-else-if="record.storeType == 1">机构分库</a-text>
              <a-text v-else-if="record.storeType == 2">师傅分库</a-text>
            </span>
          </s-table>
        </a-tab-pane>


        <a-tab-pane tab="师傅分库" key="2">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" v-on:keyup.enter="$refs.table.refresh(true)">
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item label="师傅仓库名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-model="queryParam2.storeName" />
                  </a-form-item>
                </a-col>

                <a-col :span="6">
                  <a-form-item label="服务类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam2.serviceType" allowClear="true">
                      <a-select-option v-for="type in restaurantTypes2" v-bind:value="type.code">{{ type.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>


                <a-col :span="6">
                  <a-form-item label="师傅名字" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-model="queryParam2.workerId"></a-input>
                    <!--<a-select v-model="queryParam2.workerId" allowClear="true"-->
                    <!--showSearch-->
                    <!--optionFilterProp="children"-->
                    <!--@change="handleChange"-->
                    <!--:filterOption="filterOption"-->
                    <!--&gt;-->
                    <!--<a-select-option v-for="item in boxLis4" v-bind:value="item.userId">{{item.userName}}</a-select-option>-->
                    <!--</a-select>-->
                  </a-form-item>
                </a-col>

                <a-col :span="6">
                  <a-form-item label="结算方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam2.payment" allowClear="true">
                      <a-select-option value="0">先付款</a-select-option>
                      <a-select-option value="1">后付款</a-select-option>
                      <a-select-option value="2">配发</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>


              </a-row>
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-row>
                    <a-form-item label="所在省" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-col :span="12">
                        <a-select @change="onchange2" v-model="queryParam2.currentProvince">
                          <a-select-option v-for="item in selectAllProvince" :value="item.provinceCode">
                            {{ item.provinceName }}</a-select-option>
                        </a-select>
                      </a-col>
                      <a-col :span="12">
                        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol">
                          <a-select v-model="queryParam2.currentCity">
                            <a-select-option v-for="item in selectCityName2" :value="item.cityCode">{{ item.cityName }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                    </a-form-item>
                  </a-row>

                </a-col>


                <a-col style="float: right;margin-right: 14px">
                  <a-button type="primary" style="margin-right: 8px" @click="$refs.table2.refresh(true)">查询</a-button>
                  <a-button style="margin-left: 8px" @click="() => queryParam2 = {}">清空</a-button>
                </a-col>

              </a-row>

              <a-row :gutter="24">
                <a-col :span="16"></a-col>
                <a-col style="text-align: right">
                  <a-button style="margin-right: 8px" type="primary" v-if="addEnable" icon="plus"
                    @click="$refs.modal.add2()">新增</a-button>
                </a-col>
              </a-row>


            </a-form>
          </div>

          <div class="table-operator">


          </div>
          <s-table size="default" ref="table2" rowKey="storeId" :columns="columns2" :data="loadData2"
            :scroll="{ x: '200px' }" bordered>

            <!-- 服务类别-->
            <span slot="serviceTypes" slot-scope="text, record">
              <a-popover>
                <template slot="content">
                  <p v-for="item in record.serviceTypes">{{ item }}</p>
                </template>
                <span class="hover">{{ text }} </span>
              </a-popover>
            </span>

            <span slot="storeType" slot-scope="text, record">
              <a-text v-if="record.storeType == 0">主库 </a-text>
              <a-text v-else-if="record.storeType == 1">机构分库</a-text>
              <a-text v-else-if="record.storeType == 2">师傅分库</a-text>
            </span>

            <span slot="forbiddenStatus" slot-scope="text, record">
              <a-text v-if="record.forbiddenStatus == 0">启用 </a-text>
              <a-text v-else="record.forbiddenStatus ==1">禁用</a-text>
            </span>

            <span slot="payment" slot-scope="text, record">
              <a-text v-if="record.payment == 0">先付款 </a-text>
              <a-text v-else-if="record.payment == 1">后付款</a-text>
              <a-text v-else-if="record.payment == 2">配发</a-text>
            </span>

            <span slot="action" slot-scope="text, record">
              <a v-if="detailsEnabel" @click="detailBtn2(record)">详情</a>

              <a-divider type="vertical" />
              <a v-if="editEnabel" @click="handleEdit(record)">编辑</a>

              <a-divider type="vertical" />
              <a @click="delById(record)" v-if="record.forbiddenStatus == 0 && editEnabel">禁用</a>
              <a @click="delById(record)" v-if="record.forbiddenStatus == 1 && editEnabel">启用</a>
              <a-divider type="vertical" />
              <a @click="detailBtn(record)">服务区域</a>
              <a-divider type="vertical" />
              <a @click="accessories(record)">查看配件</a>
            </span>
          </s-table>
        </a-tab-pane>
      </a-tabs>
    </div>

    <a-modal title="详情" style="top: 20px;" :width="1000" v-model="dateMode2" :confirmLoading="confirmLoading"
      @ok="handleSubmit">
      <a-form :form="form">
        <a-form-item style="display:none">
          <a-input v-decorator="['storeId']" />
        </a-form-item>

        <div v-if="key == 2">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="师傅仓库名称">
            <a-input v-model="storeName" disabled="disabled" />
          </a-form-item>
        </div>
        <div v-if="key == 1">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="机构名称">
            <a-input v-model="storeName" disabled="disabled" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所在省">
            <a-select @change="onChange" v-model="currentProvince" disabled="disabled">
              <a-select-option v-for=" item in selectAllProvince2" :value="item.provinceCode">{{ item.provinceName }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所在市">
            <a-select v-model="currentCity" disabled="disabled">
              <a-select-option v-for=" item in selectCityName" :value="item.cityCode">{{ item.cityName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>

        <div v-if="key == 2">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="师傅手机号">
            <a-input maxLength="11" @change="onChange22" v-model="phone" disabled="disabled" />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="师傅姓名">
            <a-input maxLength="11" @change="onChange22" v-model="masterName" disabled="disabled" />
          </a-form-item>
        </div>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="服务省">
          <a-select disabled="disabled" v-model="provinces" mode="tags" :size="size" style="width: 200px"
            @change="onChange2">
            <a-select-option v-for="i in selectAllProvince2" :key="i.provinceCode">
              {{ i.provinceName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="服务市">
          <a-select disabled="disabled" v-model="citys2" mode="tags" :size="size" style="width: 200px"
            @change="onChange3">
            <a-select-option v-for="i in selectCityName2" :key="i.cityCode">
              {{ i.cityName }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="服务类别">
          <a-select disabled="disabled" v-model="serviceTypes" mode="tags" :size="size" style="width: 200px"
            @change="handleChange3">
            <a-select-option v-for="type in restaurantTypes2" :key="type.code">
              {{ type.label }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="结算方式">
          <a-select v-model="payment" disabled="disabled">
            <a-select-option value="0">先付款</a-select-option>
            <a-select-option value="1">后付款</a-select-option>
            <a-select-option value="2">配发</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-input v-model="remark" disabled="disabled" />
        </a-form-item>
      </a-form>
    </a-modal>



    <a-modal title="服务区" style="top: 20px;" :width="1000" v-model="dateMode3" :confirmLoading="confirmLoading"
      @ok="handleSubmit2">
      <a-form :form="form2">

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="服务省">
          <a-select v-model="serviceProvinceList" mode="tags" :size="size" style="width: 200px" @change="onChange2">
            <a-select-option v-for="i in selectAllProvince" :key="i.provinceCode">
              {{ i.provinceName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="服务区">
          <a-select v-model="serviceCityList" mode="tags" :size="size" style="width: 200px" @change="onChange3">
            <a-select-option v-for="i in selectCityName2" :key="i.cityCode">
              {{ i.cityName }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>

    </a-modal>

    <a-modal title="配件" style="top: 20px;" :width="1000" v-model="dateMode4" :confirmLoading="confirmLoading"
      @ok="handleSubmit3">
      <a-table size="default" ref="table" rowKey="storeId" :columns="columns3" :data-source="partsId" bordered
        :scroll="{ x: '2000px' }">
      </a-table>

    </a-modal>

    <store-modal ref="modal" @ok="handleOk(arguments, userDefined)" />
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { getSelectTree, system, selectCityName, getonestore, updatearea, selectAllProvince, selectenterprise, provinceCodeList, delStore, forbidden, getStorageAccessoryList, selectuser, organstorelist, area, workerstorelist } from '@/api/accessory/store2'
import StoreModal from './modules/StoreModal.vue'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../utils/dict'
import TagSelectOption from '../../components/TagSelect/TagSelectOption'
const getdata1 = []
export default {
  name: 'TableList',
  components: {
    TagSelectOption,
    STable,
    StoreModal
  },
  data() {
    return {
      // 查看配件列表
      partsId: '',
      // 企业列表
      data2: '',
      masterName: '',
      phone: '',
      provinces: '',
      citys2: '',
      organStoreEnterprises: '',
      storePersions: '',
      serviceTypes: '',
      payment: '',
      remark: '',

      boxLis5: '',
      boxLis4: '',
      boxLis3: '',
      selectAllProvince: '',
      selectAllProvince2: '',
      storeId: '',
      serviceCityList: '',
      serviceProvinceList: '',

      selectCityName2: '',
      selectCityName: '',
      boxLis: '',
      currentCity: '',
      currentProvince: '',
      key: 1,
      // 服务区域
      area: '',
      // 服务器区域
      areas: '',
      // 仓库服务类型
      types: '',
      // 负责人
      persions: '',
      // 可用企业
      enterprises: '',
      // 详情
      details: '',
      dateMode4: false,
      // 详情判断
      dateMode2: false,
      // 服务区域
      dateMode3: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      queryParam2: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: '80px',
          dataIndex: 'num',
          align: 'center'
        },
        {
          title: '操作',
          width: '200px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '机构名称',
          dataIndex: 'storeName',
          align: 'center'
        },
        {
          title: '仓库类型',
          dataIndex: 'storeType',
          align: 'center',
          scopedSlots: { customRender: 'storeType' }
        },
        // {
        //   title: '师傅id',
        //   dataIndex: 'workerId'
        // },
        {
          title: '服务类别',
          dataIndex: 'serviceTypes[0]',
          align: 'center',
          scopedSlots: { customRender: 'serviceTypes' }
        },
        {
          title: '可使用企业',
          dataIndex: 'organStoreEnterprises[0]',
          align: 'center',
          scopedSlots: { customRender: 'organStoreEnterprises' },
        },
        {
          title: '机构负责人',
          dataIndex: 'storePersions[0]',
          align: 'center',
          scopedSlots: { customRender: 'storePersions' }
        },
        {
          title: '结算方式',
          dataIndex: 'payment',
          align: 'center',
          scopedSlots: { customRender: 'payment' }
        },
        {
          title: '禁用状态',
          dataIndex: 'forbiddenStatus',
          align: 'center',
          scopedSlots: { customRender: 'forbiddenStatus' }
        },

        {
          title: '添加时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '添加人',
          dataIndex: 'createBy',
          align: 'center'
        },

      ],
      columns2: [
        {
          title: '序号',
          width: '80px',
          dataIndex: 'num',
          align: 'center'
        },
        {
          title: '操作',
          width: '200px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '师傅仓库名称',
          dataIndex: 'storeName',
          align: 'center'
        },
        {
          title: '仓库类型',
          dataIndex: 'storeType',
          align: 'center',
          scopedSlots: { customRender: 'storeType' }
        },
        {
          title: '师傅名字',
          dataIndex: 'workerName',
          align: 'center'
        },
        {
          title: '服务类别',
          dataIndex: 'serviceTypes[0]',
          align: 'center',
          scopedSlots: { customRender: 'serviceTypes' }
        },

        {
          title: '结算方式',
          dataIndex: 'payment',
          align: 'center',
          scopedSlots: { customRender: 'payment' }
        },
        {
          title: '禁用状态',
          dataIndex: 'forbiddenStatus',
          align: 'center',
          scopedSlots: { customRender: 'forbiddenStatus' }
        },

        {
          title: '添加时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '添加人',
          dataIndex: 'createBy',
          align: 'center'
        },
      ],
      columns3: [
        {
          title: '配件名称',
          dataIndex: 'accessoryName',
          align: 'center'
        },
        {
          title: '配件类型',
          dataIndex: 'accessories[0].accessoryType',
          align: 'center'
        },
        {
          title: '配件型号',
          dataIndex: 'accessories[0].accessoryCategory',
          align: 'center'
        },
        {
          title: '配件规格',
          dataIndex: 'accessories[0].accessorySpecification',
          align: 'center'
        },
        {
          title: '产品类别',
          dataIndex: 'accessories[0].installType',
          align: 'center'
        },
        {
          title: '配件单价',
          dataIndex: 'unityPrice',
          align: 'center'
        },
        {
          title: '库存数量',
          dataIndex: 'accessoryNumber',
          align: 'center'
        },
        {
          title: '警戒值',
          dataIndex: 'warningNumber',
          align: 'center'
        },
        {
          title: '入库人',
          dataIndex: 'createBy',
          align: 'center'
        },
        {
          title: '入库时间',
          dataIndex: 'createTime',
          align: 'center'
        },

      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return organstorelist(Object.assign(parameter, this.queryParam))
      },
      loadData2: parameter => {
        return workerstorelist(Object.assign(parameter, this.queryParam2))
      },

      getdata1: [],
      selectedRowKeys: [],
      selectedRows: [],
      restaurantTypes2: [],
      addEnable: checkPermission('addStore2'),
      editEnabel: checkPermission('modifyStore2'),
      removeEnable: checkPermission('stock:store:remove'),
      detailsEnabel: checkPermission('store2Info'),

    }
  },
  filters: {
  },
  async created() {
    // 企业
    selectenterprise({}).then(res => {
      console.log(res)
      this.data2 = res.rows
    })



    selectenterprise({}).then(res => {
      console.log(res)
      this.boxLis5 = res.rows
      console.log(this.boxLis5)

    })

    selectuser({ roleId: 11 }).then(res => {
      console.log(res)
      this.boxLis4 = res.rows
      console.log(this.boxLis4)
      console.log(this.commonFlag)
    })

    selectuser({ roleId: 12 }).then(res => {
      console.log(res)
      this.boxLis3 = res.rows
      console.log(this.boxLis3)
      console.log(this.commonFlag)
    })

    this.restaurantTypes2 = []
    this.restaurantOperTypeMap2 = await getDictMap('install_type');
    this.restaurantOperTypeMap2.forEach((value, key) => {
      this.restaurantTypes2.push({ code: key, label: value })
    })

    document.body.addEventListener('keyup', e => {
      if (e.keyCode == 13) {
        this.$refs.table.refresh(true)
      }
    })

    selectAllProvince().then(res => {
      console.log(res)
      this.selectAllProvince2 = res.rows
      this.selectAllProvince = res.rows
    })
  },
  methods: {

    handClear() {
      this.queryParam = {},
        this.queryParam.storeName = ""
      this.queryParam.enterpriseId = undefined
      this.queryParam.serviceType = undefined
      this.queryParam.payment = undefined
      this.queryParam.personChargeId = undefined
      this.queryParam.currentProvince = undefined
      this.queryParam.currentCity = undefined
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },

    // 获取省
    onchange2(checkedValues) {
      console.log('enterprise = ', checkedValues)
      var array1 = checkedValues
      this.modelAccessories = array1.slice()
      console.log(this.modelAccessories)
      selectCityName({ provinceCode: this.modelAccessories }).then(res => {
        console.log(res)
        this.selectCityName2 = res.rows
      })
    },
    onchange3(checkedValues) {
      console.log('enterprise = ', checkedValues)
      var array1 = checkedValues
      this.modelAccessories = array1.slice()
      console.log(this.modelAccessories)
      selectCityName({ provinceCode: this.modelAccessories }).then(res => {
        console.log(res)
        this.selectCityName2 = res.rows
      })
    },

    onChange2(checkedValues) {
      console.log(checkedValues)

      provinceCodeList({ provinceCodeList: checkedValues.join(',') }).then(res => {
        console.log(res)
        // this.selectCityName2 = res
        let rows = res
        let result = []
        for (let i = 0; i < rows.length; i++) {
          console.log(rows[i])
          result = result.concat(rows[i]);
        }
        this.selectCityName2 = result
        console.log(this.selectCityName2)
      })

    },

    callback(key) {
      this.key = key
      console.log(key);
    },

    // 查看机构配件
    accessories(record) {
      this.dateMode4 = true
      getStorageAccessoryList({ storeId: record.storeId }).then(res => {
        if (res.code === 0) {
          console.log(res.rows)
          this.partsId = res.rows

          // this.dateMode3 = false
          // this.handleOk()
        } else {
          this.$message.success(res.msg)
        }
      })
      //this.$router.push({name:'StorageAccessoryList'})
      // this.$router.push('storageAccessoryList')
    },
    handleSubmit() {
      this.dateMode2 = false
    },

    handleSubmit3() {
      this.dateMode4 = false
    },

    handleSubmit2(e) {
      const purchaseOrder = {
        citys: this.serviceCityList,
        storeId: this.storeId
      };
      console.log(purchaseOrder)
      console.log('Received values of form: ', purchaseOrder)
      this.confirmLoading = true
      updatearea(purchaseOrder).then(res => {
        if (res.code === 0) {
          this.$message.success('保存成功')
          this.dateMode3 = false
          this.$emit('ok')
        } else {
          this.$message.success(res.msg)
        }
      }).catch(() => {
        this.$message.error('系统错误，请稍后再试')
      }).finally(() => {
        this.confirmLoading = false
      })

    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleAdd() {
      if (this.key == 2) {
        this.$refs.modal.add2()
      } else {
        this.$refs.modal.add()
      }
    },
    handleEdit(record) {
      if (record.forbiddenStatus == 1) {
        this.$message.error('已禁用')
      } else {
        this.$refs.modal.edit(record)
      }
    },
    handleOk(userDefined) {
      console.log('userDefined', userDefined)
      if (userDefined[0] == 1) {
        this.$refs.table.refresh(false)
        this.$refs.table2.refresh(false)
      } else {
        this.$refs.table.refresh(true)
        this.$refs.table2.refresh(true)
      }

      console.log('handleSaveOk')
    },
    detailBtn(record) {
      if (record.forbiddenStatus == 1) {
        this.$message.error('已禁用')
      } else {
        this.dateMode3 = true
        selectenterprise({}).then(res => {
          console.log(res)
          this.boxLis = res.rows
          console.log(this.boxLis)
          console.log(this.commonFlag)
        })

        this.storeId = record.storeId
        area({ storeId: record.storeId }).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.area = res.data
            this.serviceProvinceList = res.data.serviceProvinceList
            if (res.data.serviceProvinceList != null) {
              provinceCodeList({ provinceCodeList: this.serviceProvinceList.join(',') }).then(res => {
                console.log(res)
                // this.selectCityName2 = res
                let rows = res
                let result = []
                for (let i = 0; i < rows.length; i++) {
                  console.log(rows[i])
                  result = result.concat(rows[i]);
                }
                this.selectCityName2 = result
                console.log(this.selectCityName2)

              })
            }

            this.serviceCityList = res.data.serviceCityList
            this.$refs.table.refresh(false)
            this.$refs.table2.refresh(false)
          } else {
            this.$message.error(res.msg)
          }
          this.selectedRowKeys = []
        })
      }
    },

    // 详情
    detailBtn2(record) {
      this.dateMode2 = true
      if (this.key == 2) {
        getonestore({ 'storeId': record.storeId }).then(res => {
          console.log(res)
          this.storeName = res.data.storeName
          this.currentCity = res.data.currentCity
          this.currentProvince = res.data.currentProvince
          if (res.data.currentProvince != null) {
            selectCityName({ provinceCode: res.data.currentProvince }).then(res => {
              console.log(res)
              this.selectCityName = res.rows
            })

          }
          this.provinces = res.data.provinces
          this.citys2 = res.data.citys
          console.log(this.citys)
          if (res.data.provinces != null) {
            provinceCodeList({ provinceCodeList: this.provinces.join(',') }).then(res => {
              console.log(res)
              let rows = res
              let result = []
              for (let i = 0; i < rows.length; i++) {
                console.log(rows[i])
                result = result.concat(rows[i]);
              }
              this.selectCityName2 = result
              console.log(this.selectCityName2)

            })
          }
          this.organStoreEnterprises = res.data.organStoreEnterprises
          this.storePersions = res.data.storePersions
          this.serviceTypes = res.data.serviceTypes
          this.payment = res.data.payment
          this.remark = res.data.remark
          let workerId = res.data.workerId
          if (workerId != null) {
            system(workerId).then(res => {
              console.log(res)
              this.phone = res.phonenumber
              this.masterName = res.userName
            })
          }

        })
      } else {

        getonestore({ 'storeId': record.storeId }).then(res => {
          console.log(res)
          this.storeName = res.data.storeName
          this.currentCity = res.data.currentCity
          this.currentProvince = res.data.currentProvince
          if (res.data.currentProvince != null) {
            selectCityName({ provinceCode: res.data.currentProvince }).then(res => {
              console.log(res)
              this.selectCityName = res.rows
            })

          }
          this.provinces = res.data.provinces
          this.citys2 = res.data.citys
          console.log(this.citys)
          if (res.data.provinces != null) {
            provinceCodeList({ provinceCodeList: this.provinces.join(',') }).then(res => {
              console.log(res)
              let rows = res
              let result = []
              for (let i = 0; i < rows.length; i++) {
                console.log(rows[i])
                result = result.concat(rows[i]);
              }
              this.selectCityName2 = result
              console.log(this.selectCityName2)

            })
          }
          this.organStoreEnterprises = res.data.organStoreEnterprises
          this.storePersions = res.data.storePersions
          this.serviceTypes = res.data.serviceTypes
          this.payment = res.data.payment
          this.remark = res.data.remark

        })
      }
    },
    detailBtn3(storeId) {
      this.dateMode4 = true
      getonestore({ 'storeId': storeId }).then(res => {
        let that = this
        console.log(res)
        this.storeName = res.data.storeName
        this.currentCity = res.data.currentCity
        this.currentProvince = res.data.currentProvince
        if (res.data.currentProvince != null) {
          selectCityName({ provinceCode: res.data.currentProvince }).then(res => {
            console.log(res)
            this.selectCityName = res.rows
          })

        }
        this.provinces = res.data.provinces
        that.citys = res.data.citys
        console.log(that.citys)
        if (res.data.provinces != null) {
          provinceCodeList({ provinceCodeList: this.provinces.join(',') }).then(res => {
            console.log(res)
            // this.selectCityName2 = res
            let rows = res
            let result = []
            for (let i = 0; i < rows.length; i++) {
              console.log(rows[i])
              result = result.concat(rows[i]);
            }
            this.selectCityName2 = result
            console.log(this.selectCityName2)

          })
        }
        this.organStoreEnterprises = res.data.organStoreEnterprises
        this.storePersions = res.data.storePersions
        this.serviceTypes = res.data.serviceTypes
        this.payment = res.data.payment
        this.remark = res.data.remark

      })
    },

    delById(record) {
      var forbiddenStatus = record.forbiddenStatus
      if (record.forbiddenStatus == "0") {
        var forbiddenStatus = "1"
      } else {
        var forbiddenStatus = "0"
      }
      var storeId = record.storeId
      forbidden({ storeId: storeId, forbiddenStatus: forbiddenStatus }).then(res => {
        console.log(res)
        if (res.code === 0) {
          if (record.forbiddenStatus == "0") {
            record.forbiddenStatus = "1"
          } else {
            record.forbiddenStatus = "0"
          }
          this.$message.success('操作成功')
          // this.handleOk()
        } else {
          this.$message.error(res.msg)
        }
        this.selectedRowKeys = []
      })
    },
    // delByIds (ids) {
    //   delstore({ ids: ids.join(',') }).then(res => {
    //     if (res.code === 0) {
    //       this.$message.success('删除成功')
    //       this.handleOk()
    //     } else {
    //       this.$message.error(res.msg)
    //     }
    //     this.selectedRowKeys = []
    //   })
    // },
    validator() {
      if (this.storeName == '' || this.storeName == null || this.storeName == undefined) {
        this.$message.success('机构名称不能为空')
        return true
      }
      if (this.currentProvince == '' || this.currentProvince == null || this.currentProvince == undefined) {
        this.$message.success('所在省不能为空')
        return true
      }
      if (this.currentCity == '' || this.currentCity == null || this.currentCity == undefined) {
        this.$message.success('所在市不能为空')
        return true
      }
      if (this.provinceId == '' || this.provinceId == null || this.provinceId == undefined) {
        this.$message.success('服务省不能为空')
        return true
      }
      if (this.cityId == '' || this.cityId == null || this.cityId == undefined) {
        this.$message.success('服务市不能为空')
        return true
      }
      if (this.enterpriseId == '' || this.enterpriseId == null || this.enterpriseId == undefined) {
        this.$message.success('可使用企业不能为空')
        return true
      }
      if (this.userId == '' || this.userId == null || this.userId == undefined) {
        this.$message.success('机构负责人不能为空')
        return true
      }
      if (this.categoryId == '' || this.categoryId == null || this.categoryId == undefined) {
        this.$message.success('服务类别不能为空')
        return true
      }
      if (this.payment == '' || this.payment == null || this.payment == undefined) {
        this.$message.success('结算方式不能为空')
        return true
      }
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}

/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>